import { render, staticRenderFns } from "./_common_top.vue?vue&type=template&id=3b669955"
import script from "./_common_top.vue?vue&type=script&lang=js"
export * from "./_common_top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b669955')) {
      api.createRecord('3b669955', component.options)
    } else {
      api.reload('3b669955', component.options)
    }
    module.hot.accept("./_common_top.vue?vue&type=template&id=3b669955", function () {
      api.rerender('3b669955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/_common_top.vue"
export default component.exports